import React from 'react';

import 'src/app/containers/Reset/ResetEmailComponent.scss';
import Layout from 'src/app/components/Layout/Layout';
import background from 'src/assets/images/background-put-email.jpg';
import LayoutLeftColumn from 'src/app/components/Layout/LayoutLeftColumn';
import LayoutRightColumn from 'src/app/components/Layout/LayoutRightColumn';
import ResetEmailFormContainer from 'src/app/containers/Reset/ResetEmailFormContainer';


const ResetEmailComponent = () => (
  <Layout>
    <LayoutLeftColumn>
      <ResetEmailFormContainer />
    </LayoutLeftColumn>
    <LayoutRightColumn background={ background }>
      <h1 styleName="welcome__headline">Nie pamiętasz hasła?</h1>
      <h2 styleName="welcome__subline">Nie martw się, zdarza się najlepszym.</h2>
    </LayoutRightColumn>
  </Layout>
);

export default ResetEmailComponent;
